export default __webpack_public_path__ + "static/media/elements-bg.86d22aca.png";